import React, {useEffect, useState} from 'react';
import MakeReport from './makeReport.js';
import ReactDOMServer from 'react-dom/server';
import './report.scss';
const PrintDataButton = ({items, issues}) => {
  const [reportPage, setReportPage] = useState(null)
  const [vehicleCts, setVehicleCounts] = useState({});
  const [oosVehicles, setoosVehicles] = useState([]);
  const [atVendorVehicles, setatVendorVehicles] = useState([]);
  const [forVendorVehicles, setforVendorVehicles] = useState([]);
  const [accidents, setAccidents] = useState([]);
  const [breakdowns, setBreakdowns] = useState([]);
  
  function getVehicleCounts(vehicles) {
      const vehicleCounts = {};

      vehicles.forEach((vehicle) => {
          const { vehicle_type_name, vehicle_status_name } = vehicle;

          // Initialize vehicle type object if it doesn't exist
          if (!vehicleCounts[vehicle_type_name]) {
          vehicleCounts[vehicle_type_name] = { total: 0 };
          }

          // Increment total count for vehicle type
          vehicleCounts[vehicle_type_name].total++;

          // Initialize vehicle status count if it doesn't exist
          if (!vehicleCounts[vehicle_type_name][vehicle_status_name]) {
          vehicleCounts[vehicle_type_name][vehicle_status_name] = 0;
          }

          // Increment count for vehicle status
          vehicleCounts[vehicle_type_name][vehicle_status_name]++;
      });

      return vehicleCounts;
  }

  function filterByVehicleStatus(vehicles, statusNames) {
    return vehicles.filter(function(vehicle) {
      return statusNames.includes(vehicle.vehicle_status_name);
    });
  }

  const getTotalIssues = items => {
    return items.reduce((acc, item) => {
      return acc + item.issues.length;
    }, 0);
  };

  function filterByIssueType(issues, issueType) {
      return issues.filter(function(issue) {
        return issue.custom_fields.breakdown_or_accident === issueType;
      });
    }
  function filterDuplicates(objects, key) {
      const seen = new Set();
      return objects.filter(object => {
        const value = object[key];
        if (seen.has(value)) {
          return false;
        } else {
          seen.add(value);
          return true;
        }
      });
    }

  function mergeArrays(vehicles, issues) {
      return vehicles.map(vehicle => {
        const matchingIssues = issues.filter((issue) => issue.asset.name === vehicle.name);
        return matchingIssues.length ? { ...vehicle, issues: matchingIssues } : null;
      }).filter(vehicle => vehicle);
    }


  useEffect(()=>{

      setoosVehicles(filterByVehicleStatus(items, ['Out of Service']));
      setatVendorVehicles(filterByVehicleStatus(items, ['At Vendor']));
      setforVendorVehicles(filterByVehicleStatus(items, ['For Vendor - Out of Service', 'For Vendor']));
      setAccidents(mergeArrays(items, filterByIssueType(issues, 'Accident')));
      setBreakdowns(mergeArrays(items, filterByIssueType(issues, 'Breakdown')));
      setVehicleCounts(getVehicleCounts(items));


  },[items, issues])
  

  const handleClick = () => {
    const printWindow = window.open();
    printWindow.document.write(ReactDOMServer.renderToString(<MakeReport oos={oosVehicles} summaryReport={vehicleCts} atVendor={atVendorVehicles} forVendor={forVendorVehicles} accidents={accidents} breakdowns={breakdowns}/>));
    printWindow.print();
  };

  return (
    <button className='print-report-button' onClick={handleClick}>
      Print Report
    </button>
  );
};

export default PrintDataButton;